import CustomDropdown from '../../components/CustomDropdown/CustomDropdown';
import usePenetrationReportV2Store from '../../stores/penetrationReportV2Store';
import { ALL_FILTER_VALUE, Channel, ChannelType, Solution, SolutionType } from '../../services/penetrationReportV2/types';

const CHANNEL_OPTIONS = [
  { label: 'All channels', value: ALL_FILTER_VALUE },
  ...Object.values(Channel).map((value) => ({ label: value, value })),
];

const SOLUTION_OPTIONS = [
  { label: 'All solutions', value: ALL_FILTER_VALUE },
  ...Object.values(Solution).map((value) => ({ label: value, value })),
];

interface FilterBarProps {
  brandOptions: string[];
}

function FilterBar({ brandOptions }: FilterBarProps) {
  const filters = usePenetrationReportV2Store((s) => s.filters);
  const setBrandFilter = usePenetrationReportV2Store((s) => s.setBrandFilter);
  const setChannelFilter = usePenetrationReportV2Store((s) => s.setChannelFilter);
  const setSolutionFilter = usePenetrationReportV2Store((s) => s.setSolutionFilter);

  const brandDropdownOptions = [
    { label: 'All brands', value: ALL_FILTER_VALUE },
    ...brandOptions.map((brand) => ({ label: brand, value: brand })),
  ];

  return (
    <section className="pr2-filterbar">
      <div className="pr2-filterbar-copy">
        <strong>Market scope</strong>
        <span>Acquisition across the total addressable market</span>
      </div>
      <div className="pr2-filters">
        <div className="pr2-filter-group">
          <span className="pr2-filter-label">Brand</span>
          <CustomDropdown
            className="pr2-filter"
            value={filters.brand}
            options={brandDropdownOptions}
            onChange={setBrandFilter}
          />
        </div>
        <div className="pr2-filter-group">
          <span className="pr2-filter-label">Channel</span>
          <CustomDropdown
            className="pr2-filter"
            value={filters.channel}
            options={CHANNEL_OPTIONS}
            onChange={(value) => setChannelFilter(value as ChannelType | typeof ALL_FILTER_VALUE)}
          />
        </div>
        <div className="pr2-filter-group">
          <span className="pr2-filter-label">Solution</span>
          <CustomDropdown
            className="pr2-filter"
            value={filters.solution}
            options={SOLUTION_OPTIONS}
            onChange={(value) => setSolutionFilter(value as SolutionType | typeof ALL_FILTER_VALUE)}
          />
        </div>
      </div>
    </section>
  );
}

export default FilterBar;
